import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false,
})
export class TruncatePipe implements PipeTransform {
    /**
     *
     * @param value
     * @param limit
     * @param ellipsis
     */
    transform(value: string, limit = 23, ellipsis = '...'): string {
        if (!value) {
            return '';
        }
        return value.length > limit ? value.slice(0, limit) + ellipsis : value;
    }
}
